import '../../style/base.css';
import '../../info/index.css';
import '../../icon/index.css';
import '../../cell/index.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/collapse-item/style/index.js
// module id = 1O2T
// module chunks = 88